var ALL_DIRECTIONS = ['left', 'right', 'top', 'bottom'];
var HORIZONTAL_DIRECTIONS = ['left', 'right'];
var VERTICAL_DIRECTIONS = ['top', 'bottom'];

export { ALL_DIRECTIONS, HORIZONTAL_DIRECTIONS, VERTICAL_DIRECTIONS };
